import React from 'react';
import FormInput from '@/components/UI/FormInput';
import { Card } from '@/components/UI';
import type { TradingStrategyFormData } from '../tradingStrategyEditorSubmitPayloads';

interface BasicInformationCardProps {
    formData: TradingStrategyFormData;
    nameInputRef: React.RefObject<HTMLInputElement | null>;
    onInputChange: <Field extends keyof TradingStrategyFormData>(field: Field, value: TradingStrategyFormData[Field]) => void;
    validationErrors: Record<string, string>;
}

/**
 * Identity fields only. The active/inactive toggle lives solely in the page header so a single
 * control owns that state.
 */
const BasicInformationCard = ({ formData, nameInputRef, onInputChange, validationErrors }: BasicInformationCardProps) => (
    <Card subtitle="How this strategy is identified across backtests, journals and optimizer runs." title="Identity">
        <div className="flex flex-col gap-4">
            <FormInput
                error={validationErrors.name}
                label="Strategy name"
                placeholder="Enter strategy name"
                ref={nameInputRef}
                value={formData.name}
                onChange={(e) => onInputChange('name', e.target.value)}
            />
            <FormInput
                error={validationErrors.description}
                label="Description"
                placeholder="Enter strategy description"
                value={formData.description}
                onChange={(e) => onInputChange('description', e.target.value)}
            />
        </div>
    </Card>
);

export default BasicInformationCard;
